import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { LoadingStateService } from 'viega-common/services/loading-state-service';
import { SpecialColorSelection } from '../../../shared/SpecialColorSelection';

import { ArticleDataService } from '../../../core/article-data.service';
import { ModelDataService } from '../../../core/model-data.service';
import { PathService } from '../../../core/path.service';
import { IModel } from '../../../core/IModel';
import { IArticle } from '../../../core/IArticle';
import { PdfGeneratorService } from '../../../core/pdf-generator.service';
import { DataProviderService } from '../../../core/data-provider.service';
import { IDataSource } from '../../../core/IDataSource';
import { IHint } from '../../../core/IHint';
import { IProduct } from '../../../core/IProduct';
import { IMetalColor } from '../../../core/IMetalColor';
import { AppStateService } from 'app/core/app-state.service';

@Component({
    selector: 'article-details',
    templateUrl: './article-details.component.html',
    styleUrls: ['./article-details.component.scss']
})
export class ArticleDetailsComponent implements OnInit, OnDestroy {
    private articleHints: { [articleNo: string]: IHint[] };
    private metalColorsMap: { [id: number]: IMetalColor };
    public plate: IModel;
    public article: IArticle;
    public articleKey: string;
    public specialColor: SpecialColorSelection;

    private routeParamsSubscription: Subscription;
    private routeQueryParamsSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private pathService: PathService,
        private appState: AppStateService,
        private dataSource: DataProviderService,
        private loadingService: LoadingStateService,
        public articleService: ArticleDataService,
        private modelService: ModelDataService,
        private pdfGenerator: PdfGeneratorService
    ) {}

    public ngOnInit() {
        this.loadingService.addLoad();
        this.pdfGenerator.preloadFonts();

        this.loadingService.addLoad();
        this.dataSource.getData(true).subscribe(
            (data: IDataSource) => {
                this.articleHints = data.hints;
                this.metalColorsMap = data["metal-colors"];
            },
            console.error,
            () => this.loadingService.removeLoad());

        this.routeParamsSubscription = this.route.params.subscribe(params => {
            this.articleKey = params['akey'];

            this.articleService.getArticle(this.articleKey).subscribe(article => {
                this.article = article;

                this.modelService.getModel(article["model-key"]).subscribe(plate => {
                    this.plate = plate;
                    this.loadingService.removeLoad();
                }, console.error);
            }, console.error);
        }, console.error);

        this.routeQueryParamsSubscription = this.route.queryParams.subscribe(params => {
            const specialColorString = params['ac'];
            if (specialColorString !== undefined)
                this.specialColor = SpecialColorSelection.fromString(specialColorString);
            else
                this.specialColor = undefined;
        }, console.error);
    }

    public ngOnDestroy() {
        this.routeParamsSubscription.unsubscribe();
        this.routeQueryParamsSubscription.unsubscribe();
    }

    public generatePdf() {
        const product: IProduct = { model: this.plate, article: this.article };
        this.pdfGenerator.generatePdf([product], [], this.articleHints, this.specialColor, undefined, false, this.metalColorsMap);
    }

    public getBackQueryParams() {
        return this.appState.urlQueryParamsBaseMap();
    }
}



// WEBPACK FOOTER //
// ./src/app/mobile/articles/article-details/article-details.component.ts